import React from "react";

type TableRowProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableRowElement>,
  HTMLTableRowElement
> & {
  children: React.ReactElement;
};

/** Renders Table row
 * @param props: TableRowProps
 */
function TableRow(props: TableRowProps) {
  const { children } = props;
  return <tr {...props}>{children}</tr>;
}

export default TableRow;
